import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/mouse'; // required by jquery-ui-touch-punch
import 'jquery-ui-touch-punch';
import 'print-this';
import 'jquery-ui/ui/widgets/resizable';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { rusTimeOnly } from 'webui/utils/time';
import { binarySearchByIndex0 } from 'webui/utils/binary-search';
import { escape_html } from 'webui/utils/string';
import { isMobileApp } from 'webui/utils/version';
import '../../styles/graph-block.sass';
import get_axis from './utils/axes';
import { BottomMarkingsSeries, LineSeries, MarkingsSeries, TooltipSeries, } from './sources/base';
import { unserialize } from './sources/all';
import TimeGraph from './timegraph';
import { removeNulls } from 'utils';
function calc_offset(element, root_predicate = (el) => false) {
    if (element == null || root_predicate(element)) {
        return { left: 0, top: 0 };
    }
    const { left, top } = calc_offset(element.offsetParent, root_predicate);
    return {
        left: left + element.offsetLeft - element.scrollLeft,
        top: top + element.offsetTop - element.scrollTop,
    };
}
export class Graph extends TimeGraph {
    _yaxes;
    _fake_axis;
    _yaxes_glass;
    constructor(_yaxes, interaction_end, set_hover, interaction_start, set_unhover, view_port_change) {
        super(interaction_end, set_hover, view_port_change, interaction_start, set_unhover);
        this._fake_axis = {
            show: false,
            labelWidth: 0,
            reserveSpace: true,
        };
        this._yaxes = _yaxes;
        this._yaxes_glass = $('<div class="ui-graph-block-yaxis-glass">')
            .attr('title', 'Нажмите чтобы переключить единицы измерения')
            .appendTo(this._element.find('.ui-time-graph'));
    }
    plot = () => this._plot;
    customizePlot = (series, options) => {
        options.yaxes = this._yaxes.slice();
        if (this._fake_axis.labelWidth !== 0) {
            options.yaxes.push(this._fake_axis);
        }
        return options;
    };
    yaxes_width = () => {
        if (this._plot) {
            const label_margin = this._plot.getOptions().grid?.labelMargin;
            const axis_margin = this._plot.getOptions().grid?.axisMargin;
            let sum = 0;
            for (const axis of this._plot.getYAxes()) {
                if (axis.show && axis_margin && label_margin) {
                    if (sum > 0)
                        sum += axis_margin;
                    if (axis.labelWidth)
                        sum += axis.labelWidth;
                    sum += label_margin;
                    if (axis.tickLength && !isNaN(+axis.tickLength))
                        sum += axis.tickLength;
                }
            }
            return sum;
        }
        else
            return 0;
    };
    set_yaxes_padding = (px) => {
        const axis_margin = this._plot?.getOptions().grid?.axisMargin ?? 8;
        const label_margin = this._plot?.getOptions().grid?.labelMargin ?? 5;
        //отступ для подписи оси У графика
        const tick_length = 5; // 5 is a default axis.tickLength
        return (this._fake_axis.labelWidth =
            px - axis_margin - label_margin - tick_length);
    };
    set_crosshair = (pos) => {
        this._booleanPlot?.lockCrosshair(pos);
        this._plot?.lockCrosshair(pos);
        return;
    };
    clear_crosshair = () => {
        this._booleanPlot?.clearCrosshair();
        this._plot?.clearCrosshair();
    };
}
export class GraphBlock {
    _visible_axis_no = 0;
    _sources;
    _yaxes_keys;
    _yaxes;
    graph_height_medium;
    graph_height_mobile;
    _graph;
    _series;
    _element;
    _highlight_series_no;
    _redraw_scheduled;
    _tooltip;
    _wheel_zoom;
    _yaxis_changed;
    _block_resize;
    _set_hover;
    _set_unhover;
    _view_port_change;
    _title_block;
    _show_tooltip;
    _show_legend;
    _full_screen;
    _graph_height;
    _size_boolean_line;
    _bool_graph_on_main;
    constructor(sources, actions, height_medium = null, height_mobile = null, block_action, yaxis_changed, block_resize, set_hover, set_unhover, view_port_change, title_block, show_tooltip, show_legend, size_boolean_line, bool_graph_on_main) {
        //в параметрах устройства хранится информация о том, какой график отобразить
        this._sources = sources;
        this._yaxes_keys = [];
        this._yaxes = [];
        this._title_block = title_block;
        this._show_tooltip = show_tooltip;
        this._show_legend = show_legend;
        this._full_screen = false;
        this._bool_graph_on_main = bool_graph_on_main;
        this._view_port_change = view_port_change;
        this._yaxis_changed = yaxis_changed;
        this._block_resize = block_resize;
        this._set_hover = set_hover;
        this._set_unhover = set_unhover;
        for (const source of this._sources) {
            const key = source.yaxis_key();
            if (key == null)
                continue;
            if (this._yaxes_keys.indexOf(key) !== -1)
                continue;
            this._yaxes_keys.push(key);
            const axis = get_axis(key);
            if (axis == null) {
                console.error('undefined axis type:', key);
            }
            this._yaxes.push(axis?.create_axis_dict());
        }
        //        @_bind_to_device()
        this.graph_height_medium = height_medium;
        this.graph_height_mobile = height_mobile;
        this._size_boolean_line = size_boolean_line;
        const actual_height = isSmallUI() ? height_mobile : height_medium;
        this._graph = new Graph(this._yaxes, this.interaction_end, this._set_hover, this.interaction_start, this._set_unhover, this._view_port_change);
        this._graph.element().addClass('ui-graphs-tab-graph');
        this._graph_height = actual_height ? actual_height : 310;
        if (actual_height != null) {
            this._graph
                .element()
                .children('.ui-time-graph')
                .css('height', actual_height);
        }
        this._series = [];
        this._element = $(`
            <div class="ui-graph-block ui-card ui-card-full">
                <div class="ui-graph-block-details">
                    <div class="ui-graph-block-controls">
                      <div class="ui-graph-block-unit"></div>
                      <div class="ui-graph-block-title"></div>
                      <div class="ui-graph-block-buttons"></div>
                    </div>
                    <div class="ui-graph-block-stats"></div>
                </div>
                <div role="graph-here"></div>
                <div class="ui-graph-block-legend"></div>

                <div class="ui-graph-block-resize-handle ui-icon-graph-resize-handle ui-resizable-handle ui-resizable-s"></div>
            </div>
        `)
            .find('[role="graph-here"]')
            .replaceWith(this._graph.element())
            .end();
        this._element
            .find('.ui-graph-block-buttons')
            .html(actions
            .map(({ id, title, icon_class }) => `<a href='#' role='${id}' class='ui-graph-block-action ${icon_class}' title='${title}'></a>`)
            .join(''))
            .on('click', 'a', (ev) => {
            ev.preventDefault();
            block_action(this, $(ev.currentTarget).attr('role'));
        });
        this._element
            .find('.ui-graph-block-action.print')
            .css('display', isMobileApp() ? 'none' : 'inline-block');
        this._element.find('.ui-graph-block-title').text(this._title_block ?? '');
        this._setup_legend_hover();
        this._setup_tooltip();
        this._setup_resizing();
        this._update_yaxes_visibility();
        this._element.on('click', '.ui-graph-block-legend-title', (ev) => {
            const item = $(ev.currentTarget).closest('.ui-graph-block-legend-item');
            const itemAttr = item.attr('series-no');
            if (itemAttr) {
                const series_no = parseInt(itemAttr);
                const yaxis_no = this._yaxes_keys.indexOf(this._series[series_no].yaxis_key());
                this._visible_axis_no = yaxis_no;
            }
            this._update_yaxes_visibility();
            this._graph.redraw(this.get_Y_position_block());
            this._yaxis_changed();
        });
        this._graph._element.find('.ui-graph-block-yaxis-glass').on('click', () => {
            this._visible_axis_no++;
            if (this._visible_axis_no >= this._yaxes.length)
                this._visible_axis_no = 0;
            this._update_yaxes_visibility();
            this._graph.redraw(this.get_Y_position_block());
            this._yaxis_changed();
        });
        this._graph.set_SizeBooleanLine(this._size_boolean_line ?? 5);
        this._graph.set_boolGraphOnMain(this._bool_graph_on_main);
    }
    get_Y_position_block = () => this._element.get(0)?.getBoundingClientRect();
    interaction_start = () => {
        this._tooltip.removeClass('visible');
    };
    get_show_tooltip = () => this._show_tooltip;
    set_show_tooltip = (value) => {
        this._show_tooltip = value;
    };
    get_count_boolean_lines = () => {
        return this._graph.get_count_boolean_lines();
    };
    get_show_legend = () => this._show_legend;
    get_bool_graph_on_main = () => this._bool_graph_on_main;
    get_size_boolean_graph = () => this._size_boolean_line;
    set_show_legend = (value) => {
        this._show_legend = value;
    };
    set_full_screen = (value) => {
        this._full_screen = value;
    };
    full_screen = () => this._full_screen;
    interaction_end = () => {
        const viewport = this._graph.viewport();
        if (viewport)
            this._update_stats(viewport, this._series);
    };
    hover = throttleWithLastCall(20, (time, position) => {
        let plot = this._graph._plot;
        const booleanPlot = this._graph._booleanPlot;
        // Если  и основной график и булевые графики не отображаются, то выходим
        if (plot == null && booleanPlot == null)
            return;
        // Если не отображается только основной график, а булевые графики есть, то для отрисовки легенды, в качестве plot`а возьмем первый буделвый график
        // (работает адекватно)
        if (plot == null) {
            plot = booleanPlot;
            if (plot == null)
                return;
        }
        const plot_offset = plot.getPlotOffset();
        let x = plot.getAxes().xaxis.p2c(time * 1e3);
        if (0 > x || x >= plot.width())
            return;
        const block = this._element.get(0);
        const html = [
            `<div class=\"ui-graph-block-tooltip-time\">Время: ${rusTimeOnly(new Date(time * 1e3))}</div>`,
        ];
        const heating_mode = this._series
            .filter((ser) => ser instanceof TooltipSeries)
            .map((ser) => ser.get_tooltip_html(time))
            .filter((text) => text != null)
            .flatMap((text) => {
            return text;
        });
        const html_legend_hover = [
            ...this._series.map((el) => {
                const series = el;
                if (series == null)
                    return ``;
                if (!series.show_in_legend())
                    return ``;
                let value = null;
                let axis = null;
                if (series instanceof LineSeries) {
                    const key = series.yaxis_key();
                    if (key != null) {
                        axis = get_axis(key);
                        const value_in_series = this._find_value_in_series(series.data(), time * 1e3);
                        value_in_series != null
                            ? (value = axis.format_value(value_in_series))
                            : '';
                    }
                }
                if (series instanceof MarkingsSeries) {
                    if (series.title() === 'Отопление активно')
                        value = heating_mode[0];
                }
                const legend_type = series instanceof LineSeries ? 'series' : 'markings';
                return `<div class='ui-graph-block-hover-legend'>
                                <div class='ui-graph-block-hover-legend-title-block'>
                                    <span class='ui-graph-block-legend-color'
                                        legend-type='${legend_type}'
                                        style='background-color: ${series.color()}'>
                                    </span>
                                    <div class='ui-graph-block-hover-legend-value'>
                                      ${value ?? ''}
                                    </div>
                                    <div class='ui-graph-block-hover-legend-title'>${escape_html(series.title())}</div>
                                </div>
                            </div>
                          </div>`;
            }),
        ];
        const graph_pos = calc_offset(plot.getCanvas(), (element) => element === block);
        const position_block_relative_screenY = graph_pos.top + (this._element.offset()?.top ?? 0) + 8;
        const parent = $('.ui-graphs-tab-scrolling-area');
        const boolean_graphs = $('.ui-boolean-time-graphs');
        const plot_element = this._graph._plotElement;
        const block_stats_size = this._element
            .find('.ui-graph-block-stats')
            .outerHeight(true);
        if (position_block_relative_screenY <= position.pageY &&
            position_block_relative_screenY +
                (plot_element.height() ?? 0) +
                (boolean_graphs.height() ?? 0) >=
                position.pageY) {
            //Если мышь на основном графике, то показываем crosshair и по Х и по У
            // если мышь на булевом графике, то показывать только по Х
            if (position_block_relative_screenY + (plot_element.height() ?? 0) - 10 <=
                position.pageY) {
                this.set_crosshair({
                    x: time * 1e3,
                });
            }
            else {
                this.set_crosshair({
                    x: time * 1e3,
                    y: position.y,
                });
            }
            const padding_tooltip = 16;
            x = graph_pos.left + plot_offset.left + x;
            let y = graph_pos.top + plot_offset.top;
            const tooltip_width = this._tooltip.width();
            const tooltip_height = this._tooltip.height();
            if (this._show_tooltip === true) {
                html.push(...html_legend_hover);
                if (!this.full_screen()) {
                    x = position.pageX - (parent.offset()?.left ?? 0) + padding_tooltip;
                    y =
                        (parent.scrollTop() ?? 0) +
                            position.pageY -
                            (parent.offset()?.top ?? 0) +
                            padding_tooltip;
                    if (block) {
                        if (tooltip_width) {
                            //перенос блока в левую сторону от оси
                            const width_flag = tooltip_width + x >
                                block.offsetWidth - block.offsetLeft;
                            if (width_flag) {
                                x =
                                    x -
                                        tooltip_width -
                                        2 * padding_tooltip -
                                        block.offsetLeft;
                                if (x <= 0) {
                                    x = padding_tooltip;
                                }
                            }
                        }
                        if (tooltip_height) {
                            //перенос блока в вверх от оси (внизу экрана)
                            const height_flag = screen.height - position.pageY - 80 <
                                tooltip_height + padding_tooltip;
                            if (height_flag) {
                                y = y - tooltip_height - 2.5 * padding_tooltip;
                            }
                        }
                    }
                }
                else {
                    x = position.pageX + padding_tooltip;
                    y = position.pageY + padding_tooltip;
                    if (block) {
                        if (tooltip_width) {
                            //перенос блока в левую сторону от оси
                            const width_flag = tooltip_width + x > screen.availWidth;
                            if (width_flag) {
                                x =
                                    x -
                                        tooltip_width -
                                        3 * padding_tooltip -
                                        block.offsetLeft;
                                if (x <= 0) {
                                    x = padding_tooltip;
                                }
                            }
                        }
                        if (tooltip_height) {
                            //перенос блока в вверх от оси (внизу экрана)
                            const height_flag = screen.height - position.pageY <
                                tooltip_height + padding_tooltip;
                            if (height_flag) {
                                y = y - tooltip_height - 2.5 * padding_tooltip;
                                if (y <= 0) {
                                    y = padding_tooltip;
                                }
                            }
                        }
                    }
                }
                this._tooltip
                    .html(html.join(''))
                    .css({
                    left: `${x}px`,
                    top: `${y}px`,
                })
                    .addClass('visible');
            }
            else {
                if (block) {
                    x = x + block.offsetLeft + 3;
                    const tooltip_width = this._tooltip.width();
                    if (tooltip_width) {
                        //перенос блока в левую сторону от оси
                        const width_flag = tooltip_width + x > block.offsetWidth - block.offsetLeft;
                        if (width_flag) {
                            x = x - tooltip_width - block.offsetLeft;
                        }
                    }
                    this._tooltip
                        .html(html.join(''))
                        .css({
                        left: `${x}px`,
                        top: `${block.offsetTop +
                            plot_offset.top +
                            (block_stats_size ?? 0)}px`,
                    })
                        .addClass('visible');
                }
            }
        }
        else {
            this.set_crosshair({
                x: time * 1e3,
            });
        }
    });
    set_title_block = (value) => {
        this._title_block = value;
    };
    wheel_zoom = () => this._graph.wheel_zoom();
    set_wheel_zoom = (value) => {
        this._graph.set_wheel_zoom(value);
    };
    adjust_height = () => {
        //высота общего контейнера для всех графиков
        const element = this._graph.element();
        // контейнер для основного графика
        const time_graph_container = this._graph.element().children('.ui-time-graph');
        //контейнер для булевых графиков
        const boolean_container = this._graph
            .element()
            .children('.ui-boolean-time-graphs');
        //контейнер для все блоков (scrolling-area)
        const height_scrolling_area = this._element
            .closest('.ui-graphs-tab-scrolling-area')
            .innerHeight();
        const height_time_graph_container = parseInt(time_graph_container.css('height'), 10);
        const height_boolean_container = parseInt(boolean_container.css('height'), 10);
        if ((!!isNaN(height_time_graph_container) &&
            !!isNaN(height_boolean_container)) ||
            height_scrolling_area == null)
            return;
        this._element.find('.ui-graph-block-resize-handle').removeClass('hide');
        //изначальная высота для основного графика, которая задана в конфиге (меняется через resize)
        //@ts-ignore
        const height_time_graph_from_config = parseInt(this._graph_height ?? 210, 10);
        //Узнаем отображается или нет основной график
        const display_time_graph = this._element.find('.ui-time-graph').css('display');
        //если основной график не отображается, то его высоту зануляем, а для всего контейнера ставим высоту булевых графиков
        if (display_time_graph === 'none') {
            element.css('height', height_boolean_container);
            time_graph_container.css('height', 0);
            return;
        }
        element.css('height', height_time_graph_from_config + height_boolean_container);
        time_graph_container.css('height', height_time_graph_from_config);
        return;
    };
    adjust_height_full_screen = () => {
        //максимальная высота контейнера для full screen`a
        let full_screen_container_height = 0;
        if (isMobileApp()) {
            full_screen_container_height = window.innerHeight;
        }
        else {
            full_screen_container_height = screen.height;
        }
        //контейнер для основного графика
        const time_graph_container = this._graph.element().children('.ui-time-graph');
        //высота для основного графика
        const height_time_graph_container = parseInt(time_graph_container.css('height'), 10);
        const height_detail = $('.ui-graph-block-details').height() ?? 0;
        //контейнер для булевых графиков
        const boolean_container = this._graph
            .element()
            .children('.ui-boolean-time-graphs');
        //высота для булевых графиков
        const height_boolean_container = parseInt(boolean_container.css('height'), 10);
        if (!!isNaN(height_boolean_container) && !!isNaN(height_time_graph_container))
            return;
        //убираем иконку изменения размера
        this._element.find('.ui-graph-block-resize-handle').addClass('hide');
        //высота легенды
        const legend_height = this.element().children('.ui-graph-block-legend').height() ?? 0;
        this._graph
            .element()
            .children('.ui-time-graph')
            .css('height', full_screen_container_height -
            legend_height -
            height_detail -
            height_boolean_container -
            30);
        this._graph
            .element()
            .css('height', full_screen_container_height - legend_height - height_detail - 30);
        return;
    };
    destroy = () => {
        this._element.remove();
    };
    get_heights = () => {
        if (isSmallUI()) {
            return [this.graph_height_medium, this.graph_height()];
        }
        return [this.graph_height(), this.graph_height_mobile];
    };
    element = () => this._element;
    sources = () => this._sources;
    data_source_keys = () => {
        const q = new Set(this._sources.map((source) => source.data_source_key()));
        return [...q];
    };
    _update_yaxes_visibility = () => {
        for (let i = 0; i < this._yaxes.length; i++)
            this._yaxes[i].show = i === this._visible_axis_no;
        const key = this._yaxes_keys[this._visible_axis_no];
        if (key != null) {
            const axis = get_axis(key);
            this._element.find('.ui-graph-block-unit').text(axis?.unit() ?? '');
        }
    };
    yaxes_width = () => this._graph.yaxes_width();
    set_yaxes_full_width = (px) => {
        this._graph.set_yaxes_padding(px - this.yaxes_width());
        this._graph.setLeftMarginForBoolean(px);
        this._element.find('.ui-graph-block-unit').css('min-width', `${px}px`);
    };
    set_data = (xbounds, data) => {
        // console.log('GRAPH BLOCK set_data', data);
        //Устанавливая информацию для отображения графика на лету создаётся класс этого типа.
        this._series = this.get_series(xbounds, data);
        this._update_legend(this._series);
        this.show_legend_values();
        this._graph.setGraphData(xbounds, this.create_flot_series(this._series));
        this._graph.set_markings(this.create_markings(this._series), true);
        this._graph.set_bottom_markings(this.create_bottom_markings(this._series), true);
        const viewport = this._graph.viewport();
        if (viewport)
            this._update_stats(viewport, this._series);
        this._graph.redraw(this.get_Y_position_block());
    };
    replace_data = (data) => {
        const bounds = this._graph.bounds();
        if (bounds)
            this._series = this.get_series(bounds, data);
        this._update_legend(this._series);
        this.show_legend_values();
        this._graph.set_markings(this.create_markings(this._series), true);
        this._graph.set_bottom_markings(this.create_bottom_markings(this._series), true);
        const viewport = this._graph.viewport();
        if (viewport)
            this._update_stats(viewport, this._series);
        this.redraw();
    };
    _update_legend = (series) => {
        this._element.find('.ui-graph-block-legend').html(this._create_legend(series));
    };
    _create_legend = (series) => {
        const html = [];
        if (this._show_legend == false)
            return '';
        for (let ser_no = 0; ser_no < series.length; ser_no++) {
            const ser = series[ser_no];
            if (!ser.show_in_legend())
                continue;
            const legend_type = ser instanceof LineSeries ? 'series' : 'markings';
            html.push(`
                <div class='ui-graph-block-legend-item' series-no='${ser_no}'>
                    <span class='ui-graph-block-legend-title'>
                        <span class='ui-graph-block-legend-color'
                              legend-type='${legend_type}'
                              style='background-color: ${ser.color()}'></span>
                        <span class='ui-graph-block-legend-value'></span>
                        <span class='ui-graph-block-legend-name'>${escape_html(ser.title())}</span>
                    </span>

                </div>
            `);
        }
        return html.join('');
    };
    //data - все доступные классы для создания
    get_series = (xbounds, data) => {
        return this._sources.flatMap((source) => {
            const source_data = data[source.data_source_key()];
            // console.log('GRAPH BLOCK get_series source_data', source_data);
            if (source_data == null) {
                return [];
            }
            const result = source.get_series(xbounds, source_data);
            // console.log('GRAPH BLOCK source.get_series', xbounds, result);
            return result;
        });
    };
    create_flot_series = (series) => {
        return series
            .map((ser, ser_no) => {
            if (!(ser instanceof LineSeries))
                return null;
            const yaxis_no = this._yaxes_keys.indexOf(ser.yaxis_key()) + 1;
            const line = ser.create_flot_series();
            line.yaxis = yaxis_no;
            if (this._highlight_series_no != null) {
                if (ser_no === this._highlight_series_no && line.lines) {
                    line.lines.lineWidth = Math.max(3, line.lines.lineWidth ?? 3);
                }
                else {
                    //@ts-ignore
                    line.color = $.color
                        .parse(line.color)
                        .scale('a', 0.25)
                        .toString();
                }
            }
            return line;
        })
            .filter((series) => series != null);
    };
    create_markings = (series) => {
        return removeNulls(series
            .filter((ser) => ser instanceof MarkingsSeries)
            .flatMap((ser) => [ser.get_markings_data()]));
    };
    create_bottom_markings = (series) => {
        return removeNulls(series
            .filter((ser) => ser instanceof BottomMarkingsSeries)
            .flatMap((ser) => [ser.get_markings_data()]));
    };
    loading = (onoff) => {
        this._graph.set_loading(onoff);
        this._element.toggleClass('ui-graph-block-loading', !!onoff);
    };
    redraw = debounce(500, () => {
        this.resize();
        this._graph.replaceGraphData(this.create_flot_series(this._series));
        this._graph.redraw(this.get_Y_position_block());
    });
    resize = () => {
        if (this._full_screen) {
            window.setImmediate(() => this.adjust_height_full_screen());
        }
        else {
            window.setImmediate(() => this.adjust_height());
        }
    };
    get_viewport = () => this._graph.viewport();
    set_viewport = throttleWithLastCall(100, (vp, no_event) => {
        this._graph.set_viewport(vp, true);
        this._graph.redraw(this.get_Y_position_block());
        this._update_stats(vp, this._series);
    });
    set_crosshair = (pos) => {
        this._graph.set_crosshair(pos);
    };
    clear_crosshair = () => {
        this._graph.clear_crosshair();
    };
    graph_height = () => this._graph.element().children('.ui-time-graph').height() || null;
    serialize = () => {
        const [height, height_mobile] = this.get_heights();
        if (isSmallUI()) {
            this._graph_height = height_mobile;
        }
        else {
            this._graph_height = height;
        }
        return {
            show_tooltip: this._show_tooltip !== undefined ? this._show_tooltip : false,
            show_legend: this._show_legend !== undefined ? this._show_legend : true,
            title_block: this._title_block,
            sources: this._sources.map((src) => src.serialize()),
            height,
            height_mobile,
            size_boolean_line: this._size_boolean_line,
            bool_graph_on_main: this._bool_graph_on_main !== undefined
                ? this._bool_graph_on_main
                : false,
        };
    };
    _find_value_in_series = (series, time, { interpolate = false, nearest = true } = {}) => {
        const { l, r } = binarySearchByIndex0(series, time);
        const [li, ri] = [series[l], series[r]];
        if (ri == null)
            return null;
        if (li != null) {
            if (ri != null && interpolate)
                return li[1] + ((ri[1] - li[1]) * (time - li[0])) / (ri[0] - li[0]);
            if (ri != null && nearest) {
                if (ri[0] - time < time - li[0])
                    return ri[1];
                return li[1];
            }
            return li[1];
        }
        return null;
    };
    show_legend_values = () => {
        this._element
            .find('.ui-graph-block-legend-value')
            .each((i, el) => {
            const $el = $(el);
            const item = $el.closest('.ui-graph-block-legend-item');
            const itemAttr = item.attr('series-no');
            if (itemAttr) {
                const series_no = parseInt(itemAttr);
                const series = this._series[series_no];
                if (series == null)
                    return;
                if (series instanceof LineSeries) {
                    const key = series.yaxis_key();
                    if (key != null) {
                        const axis = get_axis(key);
                        const data = series.data();
                        let value = null;
                        if (data.length > 0) {
                            value = data[data.length - 1][1];
                        }
                        el.innerHTML =
                            value != null ? axis.format_value(value) : '';
                    }
                }
                if (series instanceof MarkingsSeries) {
                    // const data = series.get_markings_data().data;
                    // const time = data[data.length - 1]?.xaxis.to;
                    // if (time) {
                    //Выведет название режима, который сейчас включен!!
                    // const heating_mode_names = removeNulls(
                    //     this._series
                    //         .filter(
                    //             (ser): ser is TooltipSeries =>
                    //                 ser instanceof TooltipSeries
                    //         )
                    //         .map((ser) => ser.get_tooltip_html_last())
                    // ).flatMap((text) => text);
                    // if (heating_mode_names.length > 0) {
                    //     el.innerHTML = heating_mode_names[0];
                    // } else {
                    $el.addClass('no-value');
                    // }
                    // }
                }
                if (series instanceof BottomMarkingsSeries) {
                    // const data = series.get_markings_data().data;
                    // const time = data[data.length - 1]?.xaxis.to;
                    // if (time) {
                    //Выведет название режима, который сейчас включен!!
                    // const heating_mode_names = removeNulls(
                    //     this._series
                    //         .filter(
                    //             (ser): ser is TooltipSeries =>
                    //                 ser instanceof TooltipSeries
                    //         )
                    //         .map((ser) => ser.get_tooltip_html_last())
                    // ).flatMap((text) => text);
                    // if (heating_mode_names.length > 0) {
                    //     el.innerHTML = heating_mode_names[0];
                    // } else {
                    $el.addClass('no-value');
                    // }
                    // }
                }
            }
        });
    };
    show_legend_values_for = debounce(50, (time) => {
        const heating_mode = removeNulls(this._series
            .filter((ser) => ser instanceof TooltipSeries)
            .map((ser) => ser.get_tooltip_html(time))).flatMap((text) => text);
        this._element
            .find('.ui-graph-block-legend-value')
            .each((i, el) => {
            const $el = $(el);
            const item = $el.closest('.ui-graph-block-legend-item');
            const itemAttr = item.attr('series-no');
            if (itemAttr) {
                const series_no = parseInt(itemAttr);
                const series = this._series[series_no];
                if (series == null)
                    return;
                if (series instanceof LineSeries) {
                    const key = series.yaxis_key();
                    if (key != null) {
                        const axis = get_axis(key);
                        const value = this._find_value_in_series(series.data(), time * 1e3);
                        el.innerHTML =
                            value != null ? axis.format_value(value) : '';
                    }
                }
                if (series instanceof MarkingsSeries) {
                    if (series.title() === 'Отопление активно')
                        el.innerHTML = heating_mode[0] ?? '';
                }
            }
        });
    });
    hide_legend_values = () => {
        this._element.find('.ui-graph-block-legend-value').empty();
    };
    _setup_legend_hover = () => {
        this._element.on('mouseenter click', '.ui-graph-block-legend-item', (ev) => {
            const item_attr = $(ev.currentTarget).attr('series-no');
            if (item_attr) {
                const series_no = parseInt(item_attr);
                this._highlight_series_no = series_no;
            }
            this.redraw();
        });
        this._element.on('mouseleave', '.ui-graph-block-legend-item', () => {
            this._highlight_series_no = null;
            this.redraw();
        });
    };
    _setup_tooltip = () => {
        //если открыт fullscreen, то добавляем тултип внутрь блока, если не, то внутрь всего контейнера для блоков
        // при закрытии fullscreen'a обязательно удалить тултип из блока и переобозначить переменную.
        const appendBlock = this.full_screen()
            ? this._element
            : $('.ui-graphs-container');
        this._tooltip = $(`
            <div class="ui-graph-block-tooltip">
                I am tooltip
            </div>
        `).appendTo(appendBlock);
    };
    _remove_tooltip = () => {
        if (!this.full_screen()) {
            this._element.find('.ui-graph-block-tooltip').remove();
        }
        this._tooltip = $('.ui-graphs-container').find('.ui-graph-block-tooltip');
    };
    _update_stats = debounce(100, (xbounds, series) => {
        const html = series
            .map((ser) => {
            return [ser.title(), ser.stats_html(xbounds)];
        })
            .filter(([_title, item_html]) => item_html != null)
            .map(([title, item_html]) => `<span class='ui-graph-block-stats-item' title='${escape_html(title ?? '')}'>${item_html}</span>`);
        if (html.length != 0) {
            this._element
                .find('.ui-graph-block-stats')
                .html(html.join('') || '&nbsp;');
        }
        else
            this._element.find('.ui-graph-block-stats').remove();
    });
    schedule_redraw = () => {
        if (this._redraw_scheduled)
            return;
        this._redraw_scheduled = true;
        window.setImmediate(() => {
            this._redraw_scheduled = false;
            this.redraw();
        });
    };
    _setup_resizing = () => {
        let min_graph_height = 0;
        let min_element_height = null;
        let boolean_graph_origin_height = null;
        let container_original_height = null;
        let graph_original_height = null;
        //@ts-ignore
        this._element.resizable({
            handles: {
                s: this._element.find('.ui-graph-block-resize-handle'),
            },
            start: () => {
                container_original_height = this._graph.element().height();
                boolean_graph_origin_height = this._graph
                    .element()
                    .find('.ui-boolean-time-graphs')
                    .height();
                graph_original_height = this._graph
                    .element()
                    .find('.ui-time-graph')
                    .height();
                if (graph_original_height != 0) {
                    min_graph_height = 80;
                }
                const elem_height = this._element.height();
                if (elem_height) {
                    min_element_height =
                        elem_height - (graph_original_height ?? 0) + min_graph_height;
                }
            },
            resize: (ev, ui) => {
                if (min_element_height)
                    ui.size.height = Math.max(ui.size.height, min_element_height);
                if (graph_original_height) {
                    //меняем размер основного графика
                    this._graph
                        .element()
                        .children('.ui-time-graph')
                        .height((container_original_height ?? 0) +
                        ui.size.height -
                        ui.originalSize.height);
                    //меняем размер всего элемента
                    this._graph
                        .element()
                        .height((container_original_height ?? 0) +
                        ui.size.height -
                        ui.originalSize.height);
                }
            },
            stop: (ev, ui) => {
                ui.element.css({ left: '', top: '', width: '', height: '' });
                this._block_resize();
            },
        });
    };
}
export const graph_block_unserialize = (device, actions, serialized, block_action, yaxis_changed, block_resize, set_hover, set_unhover, view_port_change) => {
    const sources = removeNulls(serialized.sources.map((src_config) => unserialize(src_config, device)));
    return new GraphBlock(
    //device,
    sources, actions, serialized.height, serialized.height_mobile, block_action, yaxis_changed, block_resize, set_hover, set_unhover, view_port_change, serialized.title_block, serialized.show_tooltip, serialized.show_legend, serialized.size_boolean_line, serialized.bool_graph_on_main);
};
function debounce(delay, fn) {
    let timer = null;
    return (...args) => {
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}
function throttleWithLastCall(delay, fn) {
    let wait = false;
    const callLast = debounce(delay, (...args) => fn(...args));
    return (...args) => {
        callLast(...args);
        if (!wait) {
            wait = true;
            setTimeout(() => {
                fn(...args);
                wait = false;
            }, delay);
        }
    };
}
